import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailCommentHeaderModule } from '@shared/modules/comments/components/mail-comment/mail-comment-header/mail-comment-header.module';
import { AutolinkModule } from '@shared/modules/comments/components/pipes/autolink/autolink.module';
import { AttachmentsModule } from '@shared/modules/main/common/attachments/attachments.module';
import { IconModule } from '@shared/modules/common/icon/icon.module';
import { ChangeTranslationsLanguageModule } from '@shared/modules/translations/components/change-translations-language/change-translations-language.module';
import { OpenAiDropdownOptionsModule } from '@shared/modules/open-ai/components/open-ai-dropdown-options/open-ai-dropdown-options.module';
import { CustomDropdownModule } from '@shared/ui/dropdown/custom-dropdown/custom-dropdown.module';
import { LoopTooltipModule } from '@shared/ui/tooltip/tooltip.module';
import { TagModule } from '@shared/ui/tag/tag.module';
import { BrowserExternalWindowHiddenDirective } from '@shared/ui/kit/dialog/browser-external-window-hidden.directive';
import { InlineImageClickHandlerFnPipe } from '@shared/modules/comments/components/pipes/inline-image-click-handler-fn.pipe';
import { SafeModule } from '@dta/ui/pipes/safe/safe.module';
import { ShadowedContentModule } from '@dta/ui/components/shadowed-content/shadowed-content.module';
import { MailCommentComponent } from './mail-comment.component';

@NgModule({
  declarations: [MailCommentComponent],
  imports: [
    CommonModule,
    MailCommentHeaderModule,
    AutolinkModule,
    SafeModule,
    ShadowedContentModule,
    AttachmentsModule,
    IconModule,
    ChangeTranslationsLanguageModule,
    OpenAiDropdownOptionsModule,
    CustomDropdownModule,
    LoopTooltipModule,
    TagModule,
    BrowserExternalWindowHiddenDirective,
    InlineImageClickHandlerFnPipe
  ],
  exports: [MailCommentComponent]
})
export class MailCommentModule {}
